import { jsx as _jsx, jsxs as _jsxs } from "jsx-dom/jsx-runtime";
/** @jsxImportSource jsx-dom */
import { imageFormats } from "../config";
import { Logger } from "@fruugo/utilities";
var Log = new Logger(window.environment);
export var toggleClass = function (element, className) {
    if (!element)
        return;
    if (element.classList.contains(className)) {
        element.classList.remove(className);
    }
    else {
        element.classList.add(className);
    }
};
export var getKeyboardFocusableElements = function (element) {
    var root = element || document;
    var selector = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
    var nodeList = root.querySelectorAll(selector);
    return Array.from(nodeList).filter(function (el) {
        return el instanceof HTMLElement &&
            !el.hasAttribute("disabled") &&
            el.getAttribute("aria-hidden") !== "true";
    });
};
export var disableBodyScroll = function () {
    var currentScroll = document.documentElement.scrollTop;
    document.body.style.top = -currentScroll + "px";
    document.body.classList.add("no-scroll");
};
export var enableBodyScroll = function () {
    var previousScroll = Math.abs(Number(document.body.style.top.replace("px", "")));
    document.body.style.top = "";
    document.body.classList.remove("no-scroll");
    document.documentElement.scrollTop = previousScroll;
};
export var slideUp = function (target, duration) {
    if (duration === void 0) { duration = 300; }
    target.style.maxHeight = target.scrollHeight + "px";
    target.style.maxHeight = "0";
    target.style.display = "none";
    window.setTimeout(function () {
        target.classList.remove("is-visible");
    }, duration);
};
export var slideDown = function (target) {
    if (!target)
        return;
    var getHeight = function () {
        target.style.display = "block";
        var height = target.scrollHeight + "px";
        target.style.display = "";
        return height;
    };
    var height = getHeight();
    target.classList.add("is-visible");
    target.style.maxHeight = height;
};
export var slideToggle = function (target, duration) {
    if (duration === void 0) { duration = 300; }
    if (!target)
        return;
    if (!target.classList.contains("is-visible")) {
        return slideDown(target);
    }
    else {
        return slideUp(target, duration);
    }
};
export function stringToHtml(str) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, "text/html");
    var html = doc.body.children;
    if (html.length > 1) {
        Log.warning("stringToHtml only returns single children. str: ".concat(str));
    }
    return html[0];
}
export function minWidth(width, minWidthFn, maxWidthFn) {
    var matchesCheck = null;
    function runCallbacks() {
        var mediaQuery = window.matchMedia("(min-width: ".concat(width, "px)"));
        var matches = mediaQuery.matches;
        // Only run this when matches changes rather than on every resize event
        if (matchesCheck === null || matchesCheck != matches) {
            if (matches) {
                minWidthFn && minWidthFn();
            }
            else {
                maxWidthFn && maxWidthFn();
            }
        }
        matchesCheck = matches;
    }
    runCallbacks();
    window.addEventListener("resize", runCallbacks, false);
}
export var isMobileDevice = function () {
    var mobileDevices = [
        "Android",
        "webOS",
        "iPhone",
        "iPad",
        "iPod",
        "BlackBerry",
        "IEMobile",
        "Opera Mini",
    ];
    return mobileDevices.some(function (device) { return navigator.userAgent.includes(device); });
};
export var createPictureElement = function (url, sizes, alt, cssClass, ariaHidden) {
    if (ariaHidden === void 0) { ariaHidden = false; }
    return (_jsxs("picture", { className: cssClass, children: [imageFormats.map(function (format) { return (_jsx("source", { type: "image/".concat(format.toLowerCase()), srcSet: sizes
                    .filter(function (size) { return size.format === format; })
                    .reduce(function (prev, current) { return "".concat(current.src, " ").concat(current.width, "w,").concat(prev); }, "") })); }), _jsx("img", { src: url, alt: alt, className: cssClass, "aria-hidden": ariaHidden ? "true" : "false" })] }));
};
export function getQueryParam(param) {
    var params = new URLSearchParams(window.location.search);
    var value = params.get(param);
    return value ? decodeURIComponent(value) : undefined;
}
